import React from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Divider } from '@mui/material';
import {
    Business as BusinessIcon, People as PeopleIcon, Flag as FlagIcon,
    SmartToy as ModelIcon, BarChart as UsageIcon, Schedule as ScheduleIcon,
} from '@mui/icons-material';
import TenantManagement from './TenantManagement';
import UserManagement from './UserManagement';
import FeatureFlagManagement from './FeatureFlagManagement';
import ModelConfiguration from './ModelConfiguration';
import UsageMonitoring from './UsageMonitoring';
import ScheduleManagement from './ScheduleManagement';

const AdminDashboard: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="tenants" replace />} />
            <Route path="tenants" element={<TenantManagement />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="features" element={<FeatureFlagManagement />} />
            <Route path="models" element={<ModelConfiguration />} />
            <Route path="usage" element={<UsageMonitoring />} />
            <Route path="schedules" element={<ScheduleManagement />} />
        </Routes>
    );
};

// We wrap the AdminDashboard in a simple layout with a side nav
const AdminSection: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const adminNavItems = [
        { title: 'Tenants', path: '/admin/tenants', icon: <BusinessIcon /> },
        { title: 'Users', path: '/admin/users', icon: <PeopleIcon /> },
        { title: 'Feature Flags', path: '/admin/features', icon: <FlagIcon /> },
        { title: 'Model Config', path: '/admin/models', icon: <ModelIcon /> },
        { title: 'Usage & Costs', path: '/admin/usage', icon: <UsageIcon /> },
        { title: 'Schedules', path: '/admin/schedules', icon: <ScheduleIcon /> },
    ];

    return (
        <Box sx={{ display: 'flex', gap: 3, pt: 2 }}>
            <Paper sx={{ width: 250, flexShrink: 0, alignSelf: 'flex-start' }}>
                <Typography variant="h6" sx={{ p: 2, pb: 1 }}>
                    Admin Controls
                </Typography>
                <Divider />
                <List>
                    {adminNavItems.map((item) => {
                        const isSelected = location.pathname.startsWith(item.path);
                        return (
                            <ListItem key={item.path} disablePadding>
                                <ListItemButton
                                    selected={isSelected}
                                    onClick={() => navigate(item.path)}
                                >
                                    <ListItemIcon sx={{ color: isSelected ? 'primary.main' : 'inherit' }}>
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item.title}
                                        primaryTypographyProps={{ fontWeight: isSelected ? 600 : 400 }}
                                    />
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
                </List>
            </Paper>
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                <AdminDashboard />
            </Box>
        </Box>
    );
};

export default AdminSection;
